define( function() {
	"use strict";

	return ( /^(?:checkbox|radio)$/i );
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/manipulation/var/rcheckableType.js
// module id = 467
// module chunks = 0